import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
export function StickyButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroElement = document.getElementById('hero');
      if (heroElement) {
        const rect = heroElement.getBoundingClientRect();
        setIsVisible(rect.bottom < 0);
      } else {
        setIsVisible(window.scrollY > 500);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full z-50 md:hidden glass-strong border-t-0 border-b-0 border-x-0 rounded-none shadow-[0_-10px_30px_rgba(0,0,0,0.5)] px-5 py-3 animate-fade-in-up" style={{
    animationDuration: '0.3s',
    paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))'
  }} data-id="element-268">
      <button onClick={goToCheckout} className="w-full bg-accent text-white font-bold text-sm py-4 rounded-full shadow-[0_0_15px_rgba(39,174,96,0.4)] flex items-center justify-center gap-2 active:scale-[0.98] transition-transform border border-accent-light/30" data-id="element-269">
        QUIERO PASEOS EN CALMA
        <ChevronRight className="w-5 h-5" data-id="element-270" />
      </button>
    </div>;
}